(function () {
	document.addEventListener("shopify:section:load", function () {
		const slider = new Swiper(".js-media-list", getSliderSettings);

		const subSlider = new Swiper(
			".js-media-sublist",
			getSubSliderProductSettings
		);

		setTimeout(function () {
			slider.update();
			subSlider.update();
		}, 200);
	});
})();

let attached = false;

let imageContainer = document.querySelector("#image");

const followMouse = (event) => {
	imageContainer.style.left = event.pageX + "px";
	imageContainer.style.top = event.pageY + "px";
};

function showImage() {
	if (!attached) {
		attached = true;
		imageContainer.style.display = "block";
		document.addEventListener("pointermove", followMouse);
	}
}

function hideImage() {
	attached = false;
	imageContainer.style.display = "";
	document.removeEventListener("pointermove", followMouse);
}

const initMobileProductGallery = (forceReinit = false) => {
	if (typeof Swiper === "undefined") return;

	document.querySelectorAll(".js-mobile-product-gallery").forEach((gallery) => {
		// If forcing reinit (e.g., after variant change), destroy existing swiper first
		if (forceReinit && gallery.swiper) {
			gallery.swiper.destroy(true, true);
		}
		
		// Skip if swiper already exists and we're not forcing reinit
		if (gallery.swiper && !forceReinit) return;

		const paginationEl = gallery.querySelector(".swiper-pagination");

		new Swiper(gallery, {
			slidesPerView: 1,
			spaceBetween: 12,
			watchOverflow: true,
			pagination: paginationEl
				? {
						el: paginationEl,
						clickable: true,
				  }
				: undefined,
		});
	});
};

document.addEventListener("DOMContentLoaded", initMobileProductGallery);
document.addEventListener("shopify:section:load", initMobileProductGallery);
// Reinitialize mobile gallery when product variant changes (e.g., clicking color thumbnails)
document.addEventListener("product-variant-changed", function() {
	// Use setTimeout to ensure DOM is fully updated after innerHTML replacement
	setTimeout(function() {
		initMobileProductGallery(true);
	}, 150);
});